import { AbstractControl, ValidationErrors } from '@angular/forms';
import { forbiddenSlug } from '@shared/constants/slug-constants';

export function multipleEmailsValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return { multipleEmails: true };
    const emails = (control.value as string)?.split(',').map(email => email.trim());
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const invalidEmails = emails?.filter(email => !emailPattern.test(email));

    return !invalidEmails?.length ? { multipleEmails: true } : null;
}

export function urlValidator(control: AbstractControl): ValidationErrors | null {
    const isValidUrlPattern = /^(https?:\/\/)([\w-]+\.)+[\w-]{2,}(\/[\w\-.]*)*$/.test(control.value as string);
    return isValidUrlPattern ? { url: true } : null;
}

export function slugValidator(control: AbstractControl): ValidationErrors | null {
    const slug = (control.value as string)?.toLowerCase();
    return slug && forbiddenSlug.includes(slug) ? null : { forbiddenSlug: true } ;
}
